export default __webpack_public_path__ + "static/media/bull-bear-2.32923869.svg";